import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M21 10.97h-.04A7.96 7.96 0 0113 3v-.09a1 1 0 10-2 0v.09a7.96 7.96 0 01-7.96 7.96H3a1 1 0 000 2h.04A7.96 7.96 0 0111 20.92a1 1 0 002 0 7.96 7.96 0 017.96-7.95H21a1 1 0 000-2zM25 23.04h-.04A3.96 3.96 0 0121 19.1V19a1 1 0 00-2 0v.09a3.96 3.96 0 01-3.96 3.95H15a1 1 0 000 2h.04A3.96 3.96 0 0119 29a1 1 0 002 0 3.96 3.96 0 013.96-3.96H25a1 1 0 000-2z"/><circle cx="27" cy="16" r="3"/>';
export var SparkleSVG = function SparkleSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
SparkleSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(SparkleSVG);